// components/QueueTable.jsx
import React, { useCallback } from 'react';
import { ageRanges, ageRangeLabels } from '../constants/queueConstants';
import { copyTableToClipboard, downloadTableXls } from '../../../../../../utils/exportTableExcell';
import '../StatisticaQueue.css';

const QueueTable = ({ data, loading }) => {
    // Функция для получения заголовка таблицы
    const getTableTitle = useCallback(() => {
        const currentDate = new Date().toLocaleDateString('uk-UA');
        return `Черга до ЗДО, станом на ${currentDate}`;
    }, []);

    // Обработчик копирования
    const handleCopyToClipboard = useCallback(() => {
        const title = getTableTitle();
        copyTableToClipboard('queueStatisticsTable', title, {
            removeSelectors: ['button', '.action-btn', 'input', 'img', '.expand-toggle-btn'],
            stripedEvenColor: '#ffffff',
            stripedOddColor: '#f8f9fa',
            theadColor: '#cfe2ff',
        });
    }, [getTableTitle]);

    // Обработчик скачивания
    const handleDownloadXls = useCallback(() => {
        const title = getTableTitle();
        const currentDate = new Date().toISOString().split('T')[0];
        const filename = `cherga_${currentDate}`;
        
        downloadTableXls('queueStatisticsTable', title, filename, {
            locale: 'uk-UA',
            removeSelectors: ['button', '.action-btn', 'input', 'img', '.expand-toggle-btn'],
            stripedEvenColor: '#ffffff',
            stripedOddColor: '#f8f9fa',
            theadColor: '#cfe2ff',
        });
    }, [getTableTitle]);

    if (loading) {
        return (
            <div className="loading-container">
                <div className="spinner"></div>
                <p>Завантаження даних...</p>
            </div>
        );
    }

    if (!data || data.length === 0) {
        return (
            <div className="no-data-message">
                Не має інформації в обраному періоді
            </div>
        );
    }

    const currentDate = new Date().toLocaleDateString('uk-UA');

    return (
        <>
            <div className="row mb-3">
                <div className="col-md-8">
                    <p className="reg-title text-center mb-4">
                        Черга до ЗДО, станом на {currentDate}
                    </p>
                </div>
                <div className="col-md-4 text-end">
                    <div className="btn-group btn-group-sm">
                        <button 
                            className="btn btn-outline-secondary"
                            onClick={handleCopyToClipboard}
                            title="Скопіювати таблицю для Excel"
                        >
                            <i className="bi bi-clipboard-data"></i> Копіювати
                        </button>
                        <button 
                            className="btn btn-outline-success"
                            onClick={handleDownloadXls}
                            title="Завантажити як Excel файл"
                        >
                            <i className="bi bi-file-earmark-excel"></i> .xls
                        </button>
                    </div>
                </div>
            </div>

            <div className="table-container">
                <div className="table-responsive">
                    <table className="table table-striped table-bordered table-hover" id="queueStatisticsTable">
                        <thead className="table-primary">
                            <tr>
                                <th scope="col">№</th>
                                <th scope='col'>Район</th>
                                <th scope='col'>ЗДО</th>
                                {ageRanges.map(age => (
                                    <th scope="col" key={age}>{ageRangeLabels[age]}</th>
                                ))}
                                <th scope="col">Разом</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.map((item, i) => {
                                // Подсчет общего количества по всем возрастам
                                const total = ageRanges.reduce((sum, age) => sum + (item[age] || 0), 0);
                                
                                return (
                                    <tr key={i} className={i % 2 === 0 ? 'table-light' : ''}>
                                        <td className="fw-semibold">{i + 1}</td>
                                        <td>{item.district}</td>
                                        <td className="fw-bold">{item.kindergartenNumber}</td>
                                        {ageRanges.map(age => (
                                            <td key={age} className="text-center">{item[age] || 0}</td>
                                        ))}
                                        <td className="fw-semibold text-center">{total}</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                        {data.length > 0 && (
                            <tfoot className="table-dark">
                                <tr className="fw-bold">
                                    <td colSpan="3" className="text-center">Всього:</td>
                                    {ageRanges.map(age => {
                                        const totalByAge = data.reduce((sum, item) => sum + (item[age] || 0), 0);
                                        return <td key={age} className="text-center">{totalByAge}</td>;
                                    })}
                                    <td className="text-center">
                                        {data.reduce((sum, item) => {
                                            return sum + ageRanges.reduce((ageSum, age) => ageSum + (item[age] || 0), 0);
                                        }, 0)}
                                    </td>
                                </tr>
                            </tfoot>
                        )}
                    </table>
                </div>
            </div>
        </>
    );
};

export default QueueTable;